export default "__VITE_ASSET___1GYZjtV__"